var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTriangle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 14,
    viewBox: "0 0 7 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3_849)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.56712 7.18994C6.71318 7.02765 6.78622 6.841 6.78622 6.63002C6.78622 6.41903 6.71318 6.23239 6.56712 6.07009L3.45101 2.95399C3.19134 2.72677 2.90732 2.66997 2.59895 2.78358C2.29059 2.92964 2.12829 3.17309 2.11206 3.51391V9.74612C2.12829 10.0869 2.29059 10.3304 2.59895 10.4765C2.90732 10.5901 3.19134 10.5333 3.45101 10.306L6.56712 7.18994Z",
    fill: "#ADB5BD"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3_849"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6.34,
    height: 13,
    fill: "white",
    transform: "matrix(1 0 0 -1 0.5 13.13)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTriangle);
export default __webpack_public_path__ + "static/media/triangle.0db5ccd1343282da75be842d33e769c8.svg";
export { ForwardRef as ReactComponent };